import React from 'react'

export const ShapeIcon = (shape: string, fillColor: string) => {
  switch (shape) {
    case 'rectangle':
      return (
        <svg
          width="64"
          height="80"
          viewBox="0 0 64 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="37.1445"
            y="-0.908966"
            width="32"
            height="76"
            rx="5"
            transform="rotate(30 37.1445 -0.908966)"
            fill={fillColor}
          />
        </svg>
      )
    case 'triangle':
      return (
        <svg
          width="78"
          height="75"
          viewBox="0 0 78 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.889779 66.9019L34.9388 2.65855C36.8258 -0.901901 41.9336 -0.881882 43.7927 2.69325L77.1993 66.9366C78.9301 70.2652 76.5149 74.2434 72.7632 74.2434L5.30764 74.2434C1.53876 74.2434 -0.875167 70.232 0.889779 66.9019Z"
            fill={fillColor}
          />
        </svg>
      )
    case 'circle':
      return (
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="80" height="80" rx="40" fill={fillColor} />
        </svg>
      )
    default:
      return <></>
  }
}
